import { render, staticRenderFns } from "./uniOffers.vue?vue&type=template&id=8969c79c&"
import script from "./uniOffers.vue?vue&type=script&lang=js&"
export * from "./uniOffers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8969c79c')) {
      api.createRecord('8969c79c', component.options)
    } else {
      api.reload('8969c79c', component.options)
    }
    module.hot.accept("./uniOffers.vue?vue&type=template&id=8969c79c&", function () {
      api.rerender('8969c79c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2IP21DnjwIKQZ/JS/uniOffers.vue"
export default component.exports